<script lang="ts">
  import type {
    CreateDropdownSubmenuProps,
    DropdownMenuSubmenu,
  } from "@melt-ui/svelte";
  import { melt } from "@melt-ui/svelte";
  import { ChevronRight } from "lucide-svelte";

  import DropdownItemGroup from "./DropdownItemGroup.svelte";

  export let label;
  export let createSubmenu: (
    props: CreateDropdownSubmenuProps,
  ) => DropdownMenuSubmenu;
  const {
    elements: { subTrigger, subMenu },
    states: { subOpen },
  } = createSubmenu({
    positioning: {
      placement: "right-start",
    },
  });
</script>

<div use:melt={$subTrigger}>
  <button
    class="w-full flex justify-between items-center gap-x-2 pl-2 pr-1 py-1.5 rounded-md text-left hover:bg-white/10"
    aria-expanded={$subOpen}
    on:click={(e) => {
      e.stopPropagation(); // Prevent the dropdown from closing when the submenu is clicked
    }}
  >
    <span
      class="flex-grow text-sm text-white whitespace-nowrap overflow-hidden text-ellipsis"
      >{label}</span
    >
    <ChevronRight size={16} class="text-white/50" />
  </button>
</div>

<div
  use:melt={$subMenu}
  class="rounded-lg border border-white/10 bg-ground/50 backdrop-blur-md min-w-48 z-30"
>
  <DropdownItemGroup>
    <slot />
  </DropdownItemGroup>
</div>
